import React, { FC } from 'react'

import { WithDataName } from 'common/types'

export const ViberSvg: FC<{ size?: number } & WithDataName> = ({
  size = 40,
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 40 40"
    data-name={rest['data-name']}
  >
    <g fill="none" fillRule="evenodd">
      <circle cx="20" cy="20" r="20" fill="#7360F2" fillRule="nonzero" />
      <g>
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M21.29 2.468c-.628-.58-3.17-2.425-8.83-2.45 0 0-6.675-.402-9.93 2.583C.72 4.412.083 7.063.016 10.35c-.067 3.287-.154 9.446 5.783 11.116h.006L5.8 24.015s-.038 1.032.641 1.242c.822.255 1.304-.529 2.089-1.374.43-.464 1.025-1.146 1.473-1.667 4.06.342 7.184-.44 7.539-.555.82-.266 5.459-.86 6.213-7.02.78-6.347-.376-10.363-2.464-12.173z"
          transform="translate(8 8)"
        />
        <path
          fill="#7360F2"
          fillRule="nonzero"
          d="M19.97 3.75c-.532-.482-2.826-1.924-7.615-1.945 0 0-5.67-.373-8.422 2.12-1.532 1.513-2.048 3.762-2.105 6.507-.056 2.745-.35 7.988 4.671 9.383l-.022 4.235c0 .24.038.403.175.437.098.024.246-.027.371-.152.803-.806 3.373-3.907 3.373-3.907 3.448.225 6.192-.456 6.487-.552.696-.224 4.459-.547 5.096-5.69.658-5.303-.242-8.923-2.009-10.435z"
          transform="translate(8 8)"
        />
        <path
          stroke="#FFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth=".512"
          d="M14.79 10.206c-.062-1.255-.7-1.914-1.913-1.978M16.432 10.757c.026-1.17-.32-2.147-1.039-2.932-.721-.787-1.72-1.22-3.002-1.315"
          transform="translate(8 8)"
        />
        <path
          stroke="#FFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth=".512"
          d="M18.114 11.415c-.016-2.03-.622-3.628-1.82-4.796-1.197-1.167-2.686-1.757-4.467-1.77"
          transform="translate(8 8)"
        />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M12.94 14.494s.45.038.693-.26l.472-.595c.228-.294.778-.482 1.316-.182.404.23.795.48 1.174.75.357.262 1.09.873 1.091.873.349.294.43.726.192 1.182l-.002.01c-.261.453-.593.861-.983 1.21-.005.002-.005.005-.009.007-.338.283-.671.444-.998.483-.048.008-.097.011-.146.009-.144.001-.287-.021-.424-.066l-.011-.015c-.504-.142-1.344-.498-2.744-1.27-.81-.442-1.582-.951-2.306-1.523-.363-.287-.71-.594-1.037-.92l-.035-.035-.035-.035-.035-.035-.035-.035c-.326-.328-.633-.674-.92-1.037-.572-.724-1.081-1.495-1.523-2.305-.772-1.4-1.128-2.24-1.27-2.745l-.016-.01c-.044-.138-.066-.281-.064-.425-.003-.05 0-.098.008-.146.041-.326.202-.66.484-1 .002-.003.004-.003.007-.008.348-.39.757-.722 1.21-.983l.01-.002c.455-.237.888-.157 1.181.19.003.002.612.734.874 1.091.27.38.52.771.75 1.175.3.538.112 1.09-.183 1.316l-.594.473c-.3.242-.261.692-.261.692s.88 3.332 4.17 4.171z"
          transform="translate(8 8)"
        />
      </g>
    </g>
  </svg>
)
